import { render } from "./CTASection.vue?vue&type=template&id=05e2234a"
import script from "./CTASection.vue?vue&type=script&lang=js"
export * from "./CTASection.vue?vue&type=script&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=05e2234a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__